import React from 'react'
import { mountComponents } from '../mount'

const Pagination = React.createClass({
  getInitialState: function () {
    return { appended: false }
  },

  handleClick: function() {
    let $jsLoadMore = $('.js-load-more')

    let url = document.querySelector('a[rel=next]').getAttribute('href')

    if (url) {
      $.ajax({
        url: url,
        method: 'GET',
        dataType: 'script',
        data: {
          paginate: true
        },
        beforeSend: (() => {
          let $viewMoreBtn = $('.view-more')

          $viewMoreBtn.velocity('fadeOut', 10)
          $jsLoadMore.slideDownThenFadeIn(100)
        })
      })
      .done((data) => {
        this.setState({appended: true })
        $jsLoadMore.fadeOutThenSlideUp(10)
        mountComponents()
      })
    }
  },

  render: function() {
    return(
      <div>
        <button className='btn btn-clear btn-block btn-lg view-more' onClick={this.handleClick}>{this.props.buttonText}</button>
        <div className='js-load-more mt40 text-center velocity-hidden'>
          <div className='spinner-icon'></div>
          <div className='span loading-text ml10 fs18'>
            {this.props.loadingText}
          </div>
        </div>
      </div>
    )
  }
})

export default Pagination
